import { callApi, callApiFile, callApiFileStorage, callApiNoBlocking } from './service'
import swal from "sweetalert"


export const audienceService = {
    getPending,
    getComplete,
    updateComplete,
    getAudiceImageById,
    getLastOrDefault,
    insertView
};

async function insertView(auditoriumId) {
    return callApiNoBlocking("/backend/Auditorium/InsertView/"+auditoriumId, "POST").then((result) =>
     {}
    );
  }

async function getPending() {
    return callApi('/backend/Auditorium/Pending', 'GET', undefined, {SkipValidationToken: true,}).then((result) => {

        if (result.responseCode == '00') {
            return result.data;
        } else {
            swal({ text: result.responseMessage, icon: "error" })
            return null;
        }

    });
}

async function getComplete() {
    return callApi('/backend/Auditorium/Complete', 'GET', undefined, {SkipValidationToken: true,}).then((result) => {

        if (result.responseCode == '00') {
            return result.data;
        } else {
            swal({ text: result.responseMessage, icon: "error" })
            return null;
        }

    });
}

async function updateComplete(date, id, elements) {
    return callApi('/backend/Auditorium/Complete/' + elements + '/' + date + '/' + id, 'GET', undefined, {SkipValidationToken: true,}).then((result) => {

        if (result.responseCode == '00') {
            return result.data;
        } else {
            swal({ text: result.responseMessage, icon: "error" })
            return null;
        }

    });
}

async function getLastOrDefault(date, id) {
    return callApi(`/backend/Auditorium/Complete/LastOrDefault/${date}/${id}`, 'GET', undefined, {SkipValidationToken: true,}).then((result) => {

        if (result.responseCode == '00') {
            return result.data;
        } else {
            swal({ text: result.responseMessage, icon: "error" })
            return null;
        }

    });
}

async function getAudiceImageById(auditoriumId){
    return callApi('/backend/Auditorium/WithImages/' + auditoriumId, 'GET').then((result) => handleRsponse(result));
}

function handleRsponse(result) {
    if (result.responseCode === '00')
        return result.data;
    else {
        return null;
    }
}